// !!!!
// This is a generated file.
// Do not manually change this file
// !!!!

export const CustSupp_Type = {
    Customer: 3211264,
    Supplier: 3211265,
};
